import React, { Component } from 'react'
import DocumentMeta from 'react-document-meta'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Grid from '@material-ui/core/Grid'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import Typography from '@material-ui/core/Typography'

import Button from '../components/Button/Button'
import Carousel from '../components/Carousel/Carousel'
import ContentNode from '../components/ContentNode/ContentNode'
import Footer from '../components/Footer/Footer'
import Image from '../components/Image/Image'
import Link from '../components/Link/Link'
import News from '../components/News/News'
import Notifications from '../components/Notification/Notification'

import Request from '../services/Request/Request'

import iconBallon from '../assets/images/sprites/128x128/icon-ballon-128.png'
import iconAvatar from '../assets/images/sprites/128x128/icon-avatar-128.png'
import iconBinoculars from '../assets/images/sprites/256x256/icon-binoculars-256.png'
import iconGear from '../assets/images/sprites/256x256/icon-gear-256.png'
import iconGlobe from '../assets/images/sprites/128x128/icon-globe-128.png'
import iconHand from '../assets/images/sprites/128x128/icon-hand-128.png'
import iconPaperplane from '../assets/images/sprites/256x256/icon-paperplane-256.png'
import iconPuzzle from '../assets/images/sprites/128x128/icon-puzzle-128.png'
import iconSearch from '../assets/images/sprites/128x128/icon-search-128.png'

import imgAbout from '../assets/images/about.jpg'
import imgServices from '../assets/images/services.jpg'

import imgSlide1 from '../assets/images/slides/slide1.jpg'
import imgSlide2 from '../assets/images/slides/slide2.jpg'
import imgSlide3 from '../assets/images/slides/slide3.jpg'
import imgSlide4 from '../assets/images/slides/slide4.jpg'

import globalStyles from '../styles.js'
import theme from '../theme.js'

let styles

class HomePage extends Component {
	state = {
		page: {
			nodes: []
		},
		meta: {},
		slides: [],
		news: [],
		message_name: '',
		message_email: '',
		message_subject: '',
		message_message: ''
	}

	constructor (props) {
		super(props)

		this.handleChange = this.handleChange.bind(this)

		Request.get(`/pages/homepage`)
			.then(page => {
				page.nodes = page.nodes.reduce(function (nodes, node) {
					nodes[node.slug] = node.value
					return nodes
				}, {})
				this.setState({
					page: page,
					meta: {
						title: `${page.metaTitle} • Thetis`,
						description: page.metaDescription,
						canonical: page.canonical,
						meta: {
							charset: 'utf-8',
							name: {
								keywords: page.metaKeywords
							}
						}
					}
				})
				document.title = `Thetis • ${this.state.page.title}`
			})
			.catch(err => {
				console.error(err)
			})

		Request.get(`/slides?populate=image`)
			.then(slides => {
				this.setState({
					slides: slides
				})
			})
			.catch(err => {
				console.error(err)
			})

		Request.get(`/posts?fields=title,type,slug,excerpt,body&populate=image`)
			.then(news => {
				this.setState({
					news: news
				})
			})
			.catch(err => {
				console.error(err)
			})

		styles = {
			...globalStyles,
			slide1: {
				backgroundImage: `url(${imgSlide1})`,
				backgroundPosition: 'center center',
				backgroundSize: 'cover',
				height: '100vh'
			},
			slide2: {
				backgroundImage: `url(${imgSlide2})`,
				backgroundPosition: 'center center',
				backgroundSize: 'cover',
				height: '100vh'
			},
			slide3: {
				backgroundImage: `url(${imgSlide3})`,
				backgroundPosition: 'center center',
				backgroundSize: 'cover',
				height: '100vh'
			},
			slide4: {
				backgroundImage: `url(${imgSlide4})`,
				backgroundPosition: 'center center',
				backgroundSize: 'cover',
				height: '100vh'
			},
			avatar: {
				border: '2px solid',
				borderRadius: '50%',
				boxShadow: '0px 0px 30px -5px black',
				width: '128px'
			}
		}
	}

	handleChange(event, type) {
		this.setState({
			[`${type}_error_text`]: !event.target.value,
			[`message_${type}`]: event.target.value
		})
	}

	sendMessage(event) {
		event.preventDefault()
		let error
		['name', 'email', 'subject', 'body'].forEach(field => {
			if (!this.state[`message_${field}`]) {
				error = true
				return false
			}
		})
		if (error) {
			Notifications.show({
				type: 'error',
				title: 'All the form fields are required',
				delay: 10000
			})
		}
		return Request.post(`/messages`, {
			name: this.state.message_name,
			email: this.state.message_email,
			subject: this.state.message_subject,
			body: this.state.message_body
		})
			.then(() => {
				this.setState({
					message_name: '',
					message_email: '',
					message_subject: '',
					message_body: ''
				})
				Notifications.show({
					title: 'We have received your message and will get back to you as soon as possible!',
					delay: 10000
				})
			})
			.catch(err => {
				console.error(err)
				Notifications.show({
					type: 'error',
					title: 'We could not receive your message, please try again',
					delay: 10000
				})
			})
	}

	render() {
		return (
			<div id="homepage">
				<DocumentMeta {...this.state.meta} />
				<section id="home">
					<Carousel wrap={true} indicators={true} autoplay={true} delay={5000}>
						{this.state.slides.map(slide => {
							return (
								<Grid key={slide._id} container direction="column" justify="center" alignItems="center" style={{ ...styles.slide, ...styles.slide1, backgroundImage: `url(${slide.image.uri})` }}>
									<Grid container direction="column" justify="space-between" style={{ width: '60vw', height: '30vh' }}>
										<Typography color="textSecondary" variant="display2">
											<span>{slide.title}</span>
										</Typography>
									</Grid>
								</Grid>
							)
						})}
					</Carousel>
				</section>
				<section id="approach" style={{ ...styles.featured, ...styles.panel }}>
					<Grid container direction="column" justify="center" alignItems="center">
						<div style={styles.content}>
							<h1><ContentNode path="approach.heading" nodes={this.state.page.nodes} /></h1>
							<ContentNode path="approach.text" nodes={this.state.page.nodes} />
							<Grid className="panel" container spacing={16} direction="row" justify="space-between" alignItems="flex-start">
								<Grid item xs={6} sm={3}>
									<img src={iconPuzzle} alt="puzzle" />
									<ContentNode path="approach.puzzle" nodes={this.state.page.nodes} />
								</Grid>
								<Grid item xs={6} sm={3}>
									<img src={iconBallon} alt="ballon" />
									<ContentNode path="approach.ballon" nodes={this.state.page.nodes} />
								</Grid>
								<Grid item xs={6} sm={3}>
									<img src={iconSearch} alt="search" />
									<ContentNode path="approach.search" nodes={this.state.page.nodes} />
								</Grid>
								<Grid item xs={6} sm={3}>
									<img src={iconHand} alt="hand" />
									<ContentNode path="approach.hand" nodes={this.state.page.nodes} />
								</Grid>
							</Grid>
							{this.state.page.nodes['approach.button'] ?
								<Button role="button" fullWidth={false} size="large" style={{ fontSize: '1rem', padding: '1.3rem 3rem' }}>
									<ContentNode path="approach.button" nodes={this.state.page.nodes} />
								</Button>
								: null
							}
						</div>
					</Grid>
				</section>
				<section id="services" style={{ ...styles.panel, paddingBottom: 0 }}>
					<Grid container direction="column" justify="center" alignItems="center">
						<img src={iconGear} alt="puzzle" />
						<div style={styles.content}>
							<h1><ContentNode path="services.heading" nodes={this.state.page.nodes} /></h1>
							<ContentNode path="services.text" nodes={this.state.page.nodes} />
							<Grid className="panel" container spacing={16} direction="row" justify="space-between" alignItems="flex-start">
								<Grid item xs={12} sm={4}>
									<img src={iconGlobe} alt="globe" />
									<h2>
										<ContentNode path="services.international.title" nodes={this.state.page.nodes} />
									</h2>
									<ContentNode path="services.international.text" nodes={this.state.page.nodes} />
									{this.state.page.nodes['services.international.link'] ?
										<Link href="/services/international" variant="subheading" label={<ContentNode path="services.international.link" nodes={this.state.page.nodes} />} />
										: null
									}
								</Grid>
								<Grid item xs={12} sm={4}>
									<img src={iconAvatar} alt="training" />
									<h2>
										<ContentNode path="services.training.title" nodes={this.state.page.nodes} />
									</h2>
									<ContentNode path="services.training.text" nodes={this.state.page.nodes} />
									{this.state.page.nodes['services.training.link'] ?
										<Link href="/services/training" variant="subheading" label={<ContentNode path="services.training.link" nodes={this.state.page.nodes} />} />
										: null
									}
								</Grid>
								<Grid item xs={12} sm={4} style={styles.featuredColumn}>
									<img src={imgAbout} alt="about" style={styles.avatar} />
									<h2>
										<ContentNode path="services.about.title" nodes={this.state.page.nodes} />
									</h2>
									<ContentNode path="services.about.text" nodes={this.state.page.nodes} />
									{this.state.page.nodes['services.about.link'] ?
										<Link href="/about" variant="subheading" label={<ContentNode path="services.about.link" nodes={this.state.page.nodes} />} />
										: null
									}
								</Grid>
							</Grid>
							{this.state.page.nodes['services.button'] ?
								<Button role="button" fullWidth={false} size="large" style={{ fontSize: '1rem', padding: '1.3rem 3rem' }}>
									<ContentNode path="services.button" nodes={this.state.page.nodes} />
								</Button>
								: null
							}
						</div>
						<Grid container direction="row" alignItems="stretch">
							<Grid item xs={12} md={7} style={styles.contentDark}>
								<Grid container direction="column" justify="flex-end" alignItems="flex-end">
									<Grid item xs={12} md={8}>
										<ContentNode path="services.list" nodes={this.state.page.nodes} />
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12} md={5}>
								<Image src={imgServices} alt="Services" />
							</Grid>
						</Grid>
					</Grid>
				</section>
				<section id="news" style={{ ...styles.featured }}>
					<Grid container direction="row" justify="center" alignItems="center">
						<div style={styles.content}>
							<img src={iconBinoculars} alt="News" />
							<h1>
								<ContentNode path="news.heading" nodes={this.state.page.nodes} />
							</h1>
							<Carousel groupSize={theme.breakpoints.up('sm') ? 2 : 3} controls="outside" padding="4rem 0" spacing={16}>
								{this.state.news && this.state.news.map(post => {
									return (
										<News key={post._id} post={post} />
									)
								})}
							</Carousel>
						</div>
					</Grid>
				</section>
				<section id="contact">
					<Grid className="panel" container direction="column" justify="center" alignItems="center">
						<div style={styles.content}>
							<img src={iconPaperplane} alt="Paperplane" />
							<h1>
								<ContentNode path="contact.heading" nodes={this.state.page.nodes} />
							</h1>
							<form className="container" noValidate autoComplete="off" onSubmit={this.sendMessage.bind(this)}>
								<Grid className="panel" container direction="row" justify="space-between">
									<Grid item xs={12} sm={6} md={4}>
										<FormControl fullWidth error={this.state.name_error_text} aria-describedby={this.state.name_error_text ? 'name-error-text' : ''}>
											<InputLabel htmlFor="name" required style={{ color: theme.palette.secondary.contrastText }}>
												<ContentNode path="contact.name.label" nodes={this.state.page.nodes} />
											</InputLabel>
											<Input id="name" value={this.state.message_name} autoComplete="name fullname" onChange={event => this.handleChange(event, 'name')} />
											<FormHelperText id="name-error-text">
												<ContentNode path="contact.name.error.required" nodes={this.state.page.nodes} />
											</FormHelperText>
										</FormControl>
									</Grid>
									<Grid item xs={12} sm={6} md={4}>
										<FormControl fullWidth error={this.state.email_error_text} aria-describedby={this.state.email_error_text ? 'email-error-text' : ''}>
											<InputLabel htmlFor="email" required style={{ color: theme.palette.secondary.contrastText }}>
												<ContentNode path="contact.email.label" nodes={this.state.page.nodes} />
											</InputLabel>
											<Input id="name" value={this.state.message_email} autoComplete="email" onChange={event => this.handleChange(event, 'email')} />
											<FormHelperText id="email-error-text">
												<ContentNode path="contact.name.error.required" nodes={this.state.page.nodes} />
											</FormHelperText>
										</FormControl>
									</Grid>
									<Grid item xs={12} sm={6} md={4}>
										<FormControl fullWidth error={this.state.subject_error_text} aria-describedby={this.state.subject_error_text ? 'subject-error-text' : ''}>
											<InputLabel htmlFor="subject" required style={{ color: theme.palette.secondary.contrastText }}>
												<ContentNode path="contact.subject.label" nodes={this.state.page.nodes} />
											</InputLabel>
											<Input id="name" value={this.state.message_subject} autoComplete="subject" onChange={event => this.handleChange(event, 'subject')} />
											<FormHelperText id="subject-error-text">
												<ContentNode path="contact.subject.error.required" nodes={this.state.page.nodes} />
											</FormHelperText>
										</FormControl>
									</Grid>
									<Grid item xs={12}>
										<FormControl fullWidth error={this.state.message_error_text} aria-describedby={this.state.message_error_text ? 'message-error-text' : ''}>
											<InputLabel htmlFor="message" required style={{ color: theme.palette.secondary.contrastText }}>
												<ContentNode path="contact.message.label" nodes={this.state.page.nodes} />
											</InputLabel>
											<Input id="message" multiline rows={8} value={this.state.message_body} autoComplete="off" onChange={event => this.handleChange(event, 'body')} />
											<FormHelperText id="message-error-text">
												<ContentNode path="contact.message.error.required" nodes={this.state.page.nodes} />
											</FormHelperText>
										</FormControl>
									</Grid>
									<Grid item xs={12}>
										<Button type="submit" size="large" block={false}>
											<ContentNode path="contact.submit.label" nodes={this.state.page.nodes} />
										</Button>
									</Grid>
								</Grid>
							</form>
						</div>
					</Grid>
				</section>
				<Footer nodes={this.state.page.nodes} />
			</div >
		)
	}
}

export default HomePage



// WEBPACK FOOTER //
// ./src/pages/HomePage.js